module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAThJREFUaEPtWNGNwlAMsyc52IBNjhHYBNjkRuA2YQSYJChISIUrvIS0RdW5v3XzEtuvLy/EzB/OPH+ogE8rKAWkQJEBWahIYPnzkAJmtgGwBbAIrHgCsCf508UOEaNv7WgBntRXIPkb5ERy+VBAOUalAEskf4WSvCPHzMoxVEBGBSnQY0NZSBbKMCALddga4h8+RAxt4oyFe86BA4DvRIxfkusWPtoLDdIGmNkKQDMpAAeSx1by15YlAhrLv5G1WxgV8Iyhxz3QYvLd95MpYGbufb8U+T5oPe5/vxT5xn/5TFmALjQ6yFp+7L7XhUbdqLpRjVX+zJb+9W80e4qeSd7NUc2sHKOigA93d8H56NmxT4a7pRhvF5A5wKbGhpq5qZPKrKcCMmyNgZUCY7CaiSkFMmyNgZ29AhfxVvUxybiGTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_board_icon_on.png
// module id = DLGz
// module chunks = 3